module.exports = __webpack_public_path__ + "static/fonts/notokr-light.251f03d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/waste-glass-bottle2/font/notokr-light.woff2
// module id = bOEX
// module chunks = 0